import React from 'react';

const PreviousNext = ({hidePrevious, hideNext, onPreviousClicked, onNextClicked}) => {

  return <div className="card my-4">
    <div className="card-body">
      <div className="row justify-content-center">
        {!hidePrevious &&
        <div className="col-auto">
          <button type="button"
                  className="col btn btn-sm btn-secondary px-3"
                  onClick={() => onPreviousClicked()}>
            Previous
          </button>
        </div>
        }
        {!hideNext &&
        <div className="col-auto">
          <button type="button"
                  className="col btn btn-sm btn-success px-4"
                  onClick={() => onNextClicked()}>
            Next
          </button>
        </div>
        }
      </div>
    </div>
  </div>;
};

export default PreviousNext;